import React, { useRef } from 'react'
import { Button, Collapse, } from '@bedrock/components'
import { useFullscreen, useMemoizedFn } from 'ahooks';
import { ExpandSquare } from '@bedrock/icons-react';
import classNames from "classnames/bind";
import styles from "./index.less";

const cx = classNames.bind(styles)

// 对齐 Collapse.Panel 的参数类型
type CollapseTablePanelProps = React.ComponentProps<typeof Collapse.Panel>

const CollapseFullscreen = function (props: CollapseTablePanelProps) {
  const { children, header, ...restProps } = props;
  const ref = useRef(null);
  const [fullscreen, options] = useFullscreen(
    ref,
    { pageFullscreen: { zIndex: 1000 } }
  );
  const handleExpandScreen = useMemoizedFn((e?: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e?.preventDefault();
    e?.stopPropagation();
    fullscreen ? options.exitFullscreen() : options.enterFullscreen();
  })

  return (
    <Collapse.Panel
      header={header}
      {...restProps}
      extra={
        <div className={cx('flex gap-2')}>
         {restProps?.extra}
         <Button
          style={{ marginRight: 18 }}
          onClick={handleExpandScreen}
          type="text-subtle"
          icon={<ExpandSquare />}
          />
        </div>
      }
      
    >
      <div
        ref={ref}
        style={{ backgroundColor: '#fff', overflow: fullscreen ? 'auto' : undefined }}
      >
        {fullscreen && <div
          className={cx('fullscreen-bar')}
        >
          <div>{header}</div>
          <Button
            onClick={handleExpandScreen}
            type="text-subtle"
            icon={<ExpandSquare />}
          />
        </div>}
        {children}
      </div>
    </Collapse.Panel>
  )
}

export default CollapseFullscreen;
